import { observable, action } from 'mobx';
import { fetch, buildUrl, fetchBlob } from '@/lib/fetchAPI';
import moment from 'moment';

function format(response) {
  return response.map(item => ({
    ...item,
    lastUpdateTime: moment(item.lastUpdateTime).format('YYYY-MM-DD HH:mm')
  }));
}

class ReportStore {
  @observable reportDate = [];
  @observable reportDateTotal = 1;
  @observable page_num = 1;

  @action
  loadReport(deviceId, clientId, status) {
    let param = buildUrl({
      size: 20,
      page: this.page_num - 1,
      deviceIds: deviceId,
      clientId,
      status
    });
    fetch(`/api/report/${param}`, { method: 'GET' }, json => {
      this.reportDate = format(json.content || []);
      this.reportDateTotal = json.totalElements;
    });
  }
  @action
  downloadReport(deviceIds, clientId, status) {
    let param = buildUrl({
      deviceIds,
      clientId,
      status
    });
    return fetchBlob(`/api/report/export${param}`, { method: 'GET' }).then(
      blob => window.URL.createObjectURL(blob)
    );
  }
}
export default new ReportStore();



// WEBPACK FOOTER //
// ./src/store/Report/Report.js